import { Component, OnInit } from '@angular/core';
import { SalesEntityService } from 'app/layout/sales-entity/sales-entity-service/sales-entity-service';
import { Router, NavigationEnd } from '@angular/router';
declare let ga: Function;
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {


	constructor(salesSvc: SalesEntityService, private router: Router) {
		// translate.addLangs(['en', 'fr', 'ur', 'es', 'fa']);
		// translate.setDefaultLang('en');
		// const browserLang = translate.getBrowserLang();
		// translate.use(browserLang.match(/en|fr|ur|es|fa/) ? browserLang : 'en');
		this.GetUserSpecificData();
	}

	ngOnInit() {

		this.router.events.subscribe((event) => {
			if (!(event instanceof NavigationEnd)) {
				return;
			} else {
				let report_page: string = event.urlAfterRedirects;
				if (report_page === '/') {
					report_page = '/dashboard';
				}
				ga('set', 'page', report_page);
				ga('send', 'pageview');
			}
			//console.log("Scrolling up"); 
			window.scrollTo(0, 0);
		});
	}

	private GetUserSpecificData() {
		console.log('Loading the app');
	}
}
